export enum FlowState {
    RUNNING = "RUNNING",
    WAITING = "WAITING",
    COMPLETED = "COMPLETED",
    COMPLETED_WITH_ERROR = "COMPLETED_WITH_ERROR",
}
